export default "__VITE_ASSET__D9UUTfn3__"